import { render } from "./BusinessCoaching.vue?vue&type=template&id=c3cb240e&scoped=true&lang=html"
import script from "./BusinessCoaching.vue?vue&type=script&lang=js"
export * from "./BusinessCoaching.vue?vue&type=script&lang=js"

import "./BusinessCoaching.vue?vue&type=style&index=0&id=c3cb240e&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-c3cb240e"

export default script